function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPaperclip = function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22863"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20178",
    style: {
      fill: "transparent"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17851",
    d: "m10.62 5.37-3.9 3.9a1.185 1.185 0 1 0 1.676 1.676l3.8-3.9a2.37 2.37 0 1 0-3.354-3.352l-3.8 3.9a3.556 3.556 0 0 0 5.029 5.029l3.708-3.7",
    transform: "translate(-.999)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
};

export default SvgPaperclip;